import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { DEFAULT_FILTER_MODEL } from 'src/constants';
import {
  setPageFilter,
  usePageFiltersStore,
  cloneFilterModel,
} from './pageFiltersStore';

/**
 * Custom hook to handle filter model state management for table views.
 *
 * @param {Object} options - Configuration options
 * @param {Object} options.dateFilterModel - Filter model from useDateFilterForTablePersist (optional)
 * @param {string} options.pageId - Custom page identifier (defaults to location.pathname)
 * @returns {Object} - { filterModel, handleSetFilterModel, location }
 */
export default function usePageFilterModel({ dateFilterModel, pageId } = {}) {
  const location = useLocation();
  const pagePath = pageId ?? location.pathname;
  const pageFilters = usePageFiltersStore();

  const selectorFilterModel = pageFilters[pagePath] ?? DEFAULT_FILTER_MODEL;

  const filterModel = dateFilterModel ?? selectorFilterModel;

  const handleSetFilterModel = useCallback(
    (filterData) => {
      if (dateFilterModel) {
        const mergedFilterModel = cloneFilterModel({
          ...dateFilterModel,
          ...filterData,
          items: [
            ...filterData.items,
            ...dateFilterModel.items.filter((itr) =>
              ['date-filter-start', 'date-filter-end'].includes(itr.id)
            ),
          ],
        });
        setPageFilter(pagePath, mergedFilterModel);
      } else {
        setPageFilter(pagePath, filterData);
      }
    },
    [dateFilterModel, pagePath]
  );

  return {
    filterModel,
    handleSetFilterModel,
    location,
  };
}
